import createReduxConstants from 'app/helpers/redux/createReduxConstants';
import keyMirror from 'keymirror';

export default createReduxConstants('USER', {
  DELETE_USER_ERROR: null,
  DELETE_USER_REQUEST: null,
  DELETE_USER_SUCCESS: null,
  FETCH_USER_REQUEST: null,
  FETCH_USER_SUCCESS: null,
  FETCH_USER_ERROR: null
});

export const PERMISSIONS = keyMirror({
  SYSTEM_MESSAGE: null,
  USER_TAKEOVER: null,
  EMAIL_TEMPLATES: null,
  REPORT_FEEDBACK: null,
  UGC_FREE_TEXT: null
});
